import { render, staticRenderFns } from "./vendor-index.vue?vue&type=template&id=53628626"
import script from "./vendor-index.vue?vue&type=script&lang=js"
export * from "./vendor-index.vue?vue&type=script&lang=js"
import style0 from "./vendor-index.vue?vue&type=style&index=0&id=53628626&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports